import React, { useState } from "react";
import HomePage from "./HomePage";
import LanguageTool from "./LanguageTool";
import BmrTool from "./BmrTool";

const App = () => {
	const [loggedIn, setLoggedIn] = useState(false);
	const [loginInfo, setLoginInfo] = useState({
		username: "",
		password: "",
		partyID: "",
	});
	const [loginError, setLoginError] = useState("");
	const [currentPage, setCurrentPage] = useState("home");

	const renderPage = () => {
		switch (currentPage) {
			case "home":
				return <HomePage setCurrentPage={setCurrentPage} />;
			case "language-tool":
				return (
					<LanguageTool
						loggedIn={loggedIn}
						setLoggedIn={setLoggedIn}
						loginInfo={loginInfo}
						setLoginInfo={setLoginInfo}
						loginError={loginError}
						setLoginError={setLoginError}
					/>
				);
			case "bmr-tool":
				return (
					<BmrTool
						loggedIn={loggedIn}
						setLoggedIn={setLoggedIn}
						loginInfo={loginInfo}
						setLoginInfo={setLoginInfo}
						loginError={loginError}
						setLoginError={setLoginError}
					/>
				);
			default:
				return <HomePage setCurrentPage={setCurrentPage} />;
		}
	};

	return (
		<div>
			<nav
				style={{
					display: "flex",
					justifyContent: "center",
					gap: "20px",
					marginBottom: "20px",
				}}
			>
				<button onClick={() => setCurrentPage("home")}>Home</button>
				<button onClick={() => setCurrentPage("language-tool")}>
					Language Tool
				</button>
				<button onClick={() => setCurrentPage("bmr-tool")}>BMR Tool</button>
			</nav>
			{renderPage()}
		</div>
	);
};

export default App;
